import { render, staticRenderFns } from "./BookingListForm.vue?vue&type=template&id=1f4a554c"
import script from "./BookingListForm.vue?vue&type=script&lang=js"
export * from "./BookingListForm.vue?vue&type=script&lang=js"
import style0 from "./BookingListForm.vue?vue&type=style&index=0&id=1f4a554c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports